(function () {

  // Obtiene el carrito actual
  const getCart = () => fetch('/cart.js').then(r => r.json());
  const totalItems = cart => cart.items.reduce((s, l) => s + l.quantity, 0);
// Descuentos correctos: 3/4/5
const TIERS = [
  { qty: 3, pct: 10 },
  { qty: 4, pct: 15 },
  { qty: 5, pct: 20 }
];

function compute(cart) {
  const items = totalItems(cart);   // ya la tienes definida arriba
  let tier = null;

  // Encuentra el tier alcanzado (3/4/5)
  for (let i = TIERS.length - 1; i >= 0; i--) {
    if (items >= TIERS[i].qty) { tier = TIERS[i]; break; }
  }

  // Siguiente umbral y cuántos faltan
  const nextTier = TIERS.find(t => items < t.qty) || null;
  const nextQty  = nextTier ? (nextTier.qty - items) : 0;

  // Progreso lineal: 20% por artículo, tope 100% (100% sólo con 5+)
  const progress = Math.min(items * 20, 100);

  return { items, tier, nextTier, nextQty, progress };
}


function render(state, root = document) {
  // Busca TODOS los contenedores de la barra (drawer y /cart)
  const containers = root.querySelectorAll('.eh-bundle-wrap');

  containers.forEach(c => {
    // 1) Relleno de la barra (forzado con !important)
    const fill = c.querySelector('.eh-bundle-fill');
    if (fill) {
      fill.style.setProperty('width', (state.progress || 0) + '%', 'important');
      fill.style.setProperty('display', 'block', 'important'); // por si el tema la oculta
    }

    // 2) Chips 2 / 3 / 4+ activos otra vez
    c.querySelectorAll('.eh-bundle-steps span').forEach(s => {
      const step = Number(s.dataset.step || 0);
      s.classList.toggle('active', state.items >= step);
    });

    // 3) Texto “Agrega X…”
    const next = c.querySelector('#eh-bundle-next');
    if (next) {
      if (state.nextQty > 0) {
        next.textContent = `${state.nextQty} artículo(s) para ${state.nextTier.pct}%`;
      } else {
        next.textContent = `¡Ya desbloqueaste ${state.tier ? state.tier.pct : 0}%!`;
      }
    }
  });
}




  // Redirige checkout con descuento
  function wireCheckout(state, root=document) {
    const btns = root.querySelectorAll('button[name="checkout"], a[href*="/checkout"]');
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const code = state.tier ? state.tier.code : null;
        const url = '/checkout' + (code ? `?discount=${encodeURIComponent(code)}` : '');
        window.location.href = url;
      });
    });
  }

  async function refresh(root=document) {
    const cart = await getCart();
    const state = compute(cart);
    render(state, root);
    wireCheckout(state, root);
  }

  function init() {
    refresh(document);
    document.addEventListener('cart:updated', () => refresh(document));
    const drawer = document.querySelector('.cart-drawer, cart-drawer, [data-cart-drawer]');
    if (drawer) {
      const mo = new MutationObserver(() => refresh(drawer));
      mo.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  function lockDrawerPan() {
  const drawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
  if (!drawer) return;

  // Drawer: solo pan vertical
  drawer.style.touchAction = 'pan-y';

  // Chips: permitir pan horizontal y evitar que burbujee al drawer
  drawer.querySelectorAll('.eh-bundle-steps').forEach(row => {
    row.style.touchAction = 'pan-x';
    row.style.webkitOverflowScrolling = 'touch';
    row.addEventListener('touchstart', e => e.stopPropagation(), { passive: true });
    row.addEventListener('touchmove',  e => e.stopPropagation(), { passive: true });
  });
}

/* === EH Fix: bloquear paneo horizontal del drawer y dejar scroll solo en los chips === */
function lockDrawerPan() {
  const drawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
  if (!drawer) return;

  // Drawer solo acepta scroll vertical
  drawer.style.touchAction = 'pan-y';
  drawer.style.overflowX = 'hidden';

  // Chips permiten scroll horizontal independiente
  drawer.querySelectorAll('.eh-bundle-steps').forEach(row => {
    row.style.touchAction = 'pan-x';
    row.style.overflowX = 'auto';
    row.style.webkitOverflowScrolling = 'touch';

    // Evitar que el gesto de los chips arrastre todo el drawer
    row.addEventListener('touchstart', e => e.stopPropagation(), { passive: true });
    row.addEventListener('touchmove', e => e.stopPropagation(), { passive: true });
  });
}

/* Hookear la función en init */
function init() {
  refresh(document);
  lockDrawerPan(); // 👈 ya queda activado

  document.addEventListener('cart:updated', () => {
    refresh(document);
    lockDrawerPan(); // 👈 re-aplica tras actualizar el carrito
  });

  const drawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
  if (drawer) {
    const mo = new MutationObserver(() => {
      refresh(drawer);
      lockDrawerPan(); // 👈 re-aplica si cambia el drawer
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }
}
/* === EH | Guardias de scroll para chips vs drawer === */
function installChipScrollGuards() {
  const drawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
  if (!drawer) return;

  // Drawer: fuerza solo vertical
  drawer.style.touchAction = 'pan-y';
  drawer.style.overflowX = 'hidden';

  drawer.querySelectorAll('.eh-bundle-steps').forEach(row => {
    // Permitir scroll X en chips
    row.style.touchAction = 'pan-x';
    row.style.overflowX = 'auto';
    row.style.webkitOverflowScrolling = 'touch';

    // 1) Gestos táctiles: si detectamos paneo horizontal, evitamos que burbujee
    let startX = 0, startY = 0, scrollingX = false;
    row.addEventListener('touchstart', (e) => {
      const t = e.touches && e.touches[0]; if (!t) return;
      startX = t.clientX; startY = t.clientY; scrollingX = false;
    }, { passive: true });

    row.addEventListener('touchmove', (e) => {
      const t = e.touches && e.touches[0]; if (!t) return;
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);
      if (dx > dy) { // horizontal
        scrollingX = true;
        e.stopPropagation();
        // No hacemos preventDefault para no bloquear el scroll del propio row
      }
    }, { passive: true });

    // 2) Rueda/trackpad: consume el deltaX para que no afecte al drawer
    row.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.stopPropagation();
        // evita que algún oyente global mueva el drawer
        try { e.preventDefault(); } catch {}
        // desplaza manualmente el row si el navegador no lo hace por defecto
        row.scrollLeft += e.deltaX;
      }
    }, { passive: false });
  });
}

// Hook: re-instalar guardias cada vez que cambia el drawer
(function _ehWireGuards(){
  const run = () => installChipScrollGuards();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('cart:updated', run);

  const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
  if (drawer) {
    const mo = new MutationObserver(run);
    mo.observe(drawer, { childList: true, subtree: true });
  }
})();
/* === EH | Guardias de scroll: bloquear paneo X del drawer y permitirlo solo en chips === */
(function EH_StrongScrollGuards(){
  let startX = 0, startY = 0, startedOnChips = false;

  function isInsideChips(el) {
    return !!el && (el.closest && el.closest('.eh-bundle-steps'));
  }

  function install() {
    const drawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
    if (!drawer) return;

    // Drawer: fuerza solo vertical y sin overflow-x
    drawer.style.touchAction = 'pan-y';
    drawer.style.overflowX = 'hidden';

    // 1) Capturamos gestos al nivel del drawer ANTES que cualquier handler del tema
    ['touchstart','touchmove','pointerdown','pointermove'].forEach(evt => {
      drawer.addEventListener(evt, (e) => {
        const t = e.touches ? e.touches[0] : e;
        if (!t) return;

        if (evt === 'touchstart' || evt === 'pointerdown') {
          startX = t.clientX; startY = t.clientY;
          startedOnChips = isInsideChips(e.target);
          return;
        }

        // Movimientos
        const dx = Math.abs(t.clientX - startX);
        const dy = Math.abs(t.clientY - startY);

        // Si NO empezó en chips y el gesto es más horizontal que vertical → bloquea
        if (!startedOnChips && dx > dy) {
          try { e.preventDefault(); } catch(_) {}
          e.stopPropagation();
        }

        // Si SÍ empezó en chips y es horizontal → deja que el row haga scroll, pero no burbujee
        if (startedOnChips && dx > dy) {
          e.stopPropagation();
          // no preventDefault para no romper el scroll del row
        }
      }, { passive: false, capture: true });
    });

    // 2) A nivel de cada fila de chips: permitir X y “consumir” rueda/trackpad horizontal
    drawer.querySelectorAll('.eh-bundle-steps').forEach(row => {
      row.style.touchAction = 'pan-x';
      row.style.overflowX = 'auto';
      row.style.webkitOverflowScrolling = 'touch';

      row.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          try { e.preventDefault(); } catch(_) {}
          e.stopPropagation();
          row.scrollLeft += e.deltaX;
        }
      }, { passive: false, capture: true });

      // También evita que los mousedown/drag burbujeen hacia manejadores del drawer
      ['mousedown','mousemove'].forEach(evt => {
        row.addEventListener(evt, (e) => {
          if (e.buttons === 1) e.stopPropagation();
        }, { capture: true });
      });
    });
  }

  // Ejecutar ahora y re-instalar cuando se re-renderiza el drawer
  const run = () => install();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('cart:updated', run);

  const watch = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
  if (watch) {
    const mo = new MutationObserver(run);
    mo.observe(watch, { childList: true, subtree: true });
  }
})();

})();
